var React = require('react');

function CheckboxIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"m5.48058031 10.0031636.00636968 1.9999899 5.35383741-.0170512v-10.06788807h-2.00000001v8.0742476z","fill":"currentColor","transform":"matrix(.70710678 .70710678 -.70710678 .70710678 7.312156 -3.731738)"}));
}

CheckboxIcon.defaultProps = {"height":"16","viewBox":"0 0 16 16","width":"16"};

module.exports = CheckboxIcon;

CheckboxIcon.default = CheckboxIcon;
